//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"CutPatternBuilder",0,"CAM.CutPatternBuilder",0],[1,"DpmStepoverBuilder",0,"CAM.StepoverBuilder",0],[1,"DpmStepoverMaxBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DpmStepoverMinBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DpmrcBoundaryLeftBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DpmrcBoundaryRightBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"RadCutMethod",1,0],[0,"RadStepoverType",1,0],[0,"RadTraverseDir",1,0],[1,"StepoverPercentBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"StepoverScallopBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.DmRadBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmRadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmRadBuilder.RadCutMethodType = Object.freeze({
    "Zigzag" : "Zigzag", "Zig" : "Zig"});

SPLM.CAM.DmRadBuilder.RadStepoverTypeType = Object.freeze({
    "Constant" : "Constant", "Scallop" : "Scallop", "Tool" : "Tool", "Maximum" : "Maximum"});

SPLM.CAM.DmRadBuilder.RadTraverseDirType = Object.freeze({
    "Forward" : "Forward", "Backward" : "Backward"});

export default SPLM;